var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeIcon = function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0BBC1",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4222D",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.083 20c0-3.732 0-5.598 1.16-6.758 1.159-1.159 3.025-1.159 6.757-1.159s5.598 0 6.757 1.16c1.16 1.159 1.16 3.025 1.16 6.757s0 5.598-1.16 6.757c-1.16 1.16-3.025 1.16-6.757 1.16s-5.598 0-6.758-1.16c-1.159-1.16-1.159-3.025-1.159-6.757Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4222D",
    d: "M20.75 15.833a.75.75 0 0 0-1.5 0zm1.03 4.886a.75.75 0 0 0-1.06 1.061zm.19 2.311a.75.75 0 1 0 1.06-1.06zM20 15.833h-.75v2.917h1.5v-2.917zm1.25 5.417-.53.53 1.25 1.25.53-.53.53-.53-1.25-1.25zm0-1.25h-.75a.5.5 0 0 1-.5.5V22a2 2 0 0 0 2-2zM20 21.25v-.75a.5.5 0 0 1-.5-.5H18a2 2 0 0 0 2 2zM18.75 20h.75a.5.5 0 0 1 .5-.5V18a2 2 0 0 0-2 2zM20 18.75v.75a.5.5 0 0 1 .5.5H22a2 2 0 0 0-2-2z"
  })));
};
export default SvgTimeIcon;